var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"scoreChart",style:({ maxWidth: '1100px' }),attrs:{"width":"600px","height":"150px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }